import * as React from 'react';

import useUrlState from '@ahooksjs/use-url-state';
import { useBoolean, useLockFn } from 'ahooks';
import { Button, Form, Input, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { useLoginValue } from 'context';
import { signinWithOtp } from 'services';
import { inputRule, PATHNAME } from 'utils';

import { LoginExpirationPinTime } from './expiration-time';

const {
  LOCAL: {
    HOME: { BASE_URL: HOME_BASE_URL },
  },
  QUERY_PARAM: {
    TYPE: { BASE_URL: TYPE_BASE_URL },
  },
} = PATHNAME;

type FieldType = Required<Pick<ReturnType<typeof useLoginValue>, 'otp'>>;

const LoginPinForm = () => {
  const [, setUrlState] = useUrlState(
    {
      [TYPE_BASE_URL]: '',
    },
    { navigateMode: 'replace' },
  );
  const [loading, { toggle: toggleLoading }] = useBoolean();
  const [form] = Form.useForm<FieldType>();
  const { ticket = '' } = useLoginValue();
  const navigate = useNavigate();

  const onFinish = useLockFn(async ({ otp }: FieldType) => {
    toggleLoading();

    signinWithOtp({ otp, ticket })
      .then(() => {
        navigate(HOME_BASE_URL);
        notification.success({
          message: 'با موفقیت وارد شدید.',
        });
      })
      .catch(message => {
        notification.error({ message });
      })
      .finally(() => {
        toggleLoading();
      });
  });

  return (
    <div className='basis-1/2 space-y-8'>
      <div className='text-center'>
        <Typography.Title level={2} className='text-2xl'>
          تایید کد ورود
        </Typography.Title>
        <Typography.Paragraph>
          <Typography.Text type='secondary'>
            لطفا کد ورود خود را در قسمت زیر وارد کنید.
          </Typography.Text>
        </Typography.Paragraph>
      </div>
      <PrimitiveForm form={form} onFinish={onFinish}>
        <Form.Item<FieldType>
          name='otp'
          rules={[inputRule.required, inputRule.nonWhitespace, inputRule.pin]}
        >
          <Input.OTP
            autoFocus
            style={{
              display: 'flex',
              direction: 'ltr',
            }}
            onChange={() => {
              form.submit();
            }}
          />
        </Form.Item>
        <Form.Item className='text-center'>
          <LoginExpirationPinTime />
        </Form.Item>
        <Form.Item className='mb-4'>
          <Button block type='primary' htmlType='submit' loading={loading}>
            تایید
          </Button>
        </Form.Item>
        <Form.Item className='mb-0'>
          <Button
            block
            onClick={() => {
              setUrlState({ [TYPE_BASE_URL]: undefined });
            }}
          >
            ورود با رمز ثابت
          </Button>
        </Form.Item>
      </PrimitiveForm>
    </div>
  );
};

export { LoginPinForm };
